import { Component, OnInit, Inject } from '@angular/core';
import { SystemService } from 'src/app/base/services/system.service';
import { SharingService } from '../../services/sharing.service';
import { WebpayService } from '../../services/webpay.service';
import { DOCUMENT } from '@angular/common';

@Component({
  selector: 'app-rechazado',
  templateUrl: './rechazado.component.html',
  styleUrls: ['./rechazado.component.css']
})
export class RechazadoComponent implements OnInit {

  constructor(private sharingObservable: SharingService,
    private webpay: WebpayService,
    private systemService: SystemService,
    @Inject(DOCUMENT) private document: Document) { }

  data: any;

  ngOnInit(): void {
    this.systemService.setLoading(true);

    this.sharingObservable.sharingObservable.subscribe((e: any) => {
      this.data = JSON.parse(e);
    });

    this.systemService.setLoading(false);
  }

  async volver() {
    this.systemService.setLoading(true);
    this.document.location.href = await this.webpay.setBotonVolver(window.location.href.split('?uid=')[1], this.data.urlRetorno);
    this.systemService.setLoading(false);
  }

}
